import { render, staticRenderFns } from "./productGrid.vue?vue&type=template&id=19a5db8e&"
import script from "./productGrid.vue?vue&type=script&lang=js&"
export * from "./productGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports